import React from "react";

function DropRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
    >
      <path d="M400-280v-400l200 200-200 200z"></path>
    </svg>
  );
}

export default DropRight;
